import { createAction } from 'redux-actions';
import { callApi, getEndpoint } from '../../../utils/api';

const UNCOLLECTED_SHARES = 'UNCOLLECTED_SHARES';

export default function sellUncollectedShares(
  state = {
    isLoading: false,
    isLoaded: false,
    hasFailed: false,
    error: null,
    uncollectedShares: {},
  },
  { payload, type }
) {
  switch (type) {
    case `${UNCOLLECTED_SHARES}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case `${UNCOLLECTED_SHARES}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        uncollectedShares: payload.body,
      };

    case `${UNCOLLECTED_SHARES}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasError: true,
        error: payload,
      };
    default:
      return state;
  }
}

export const getUncollectedShares = () => {
  return () => {
    const res = callApi(
      `${getEndpoint('transactionHistory')}?transactionType=Purchase`
    ); // this is supposed to be purchase because you need to know what shares have been collected via purchase
    const action = createAction(UNCOLLECTED_SHARES)(res);
    return action;
  };
};
